import { TertiaryButton } from '../../pages/common';
import styles from './About.module.css';

interface Props {
  onClose: () => void;
}

export const About = ({ onClose }: Props) => {
  return (
    <>
      <h2 className={styles.header}>About</h2>
      <p className={styles.version}>Synergi Life AI version&nbsp;{__APP_VERSION__}</p>
      <p className={styles.copyright}>© DNV AS. All rights reserved</p>
      <div className={styles.footer}>
        <TertiaryButton onClick={onClose} text="Close" type="button" />
      </div>
    </>
  );
};
